module.exports = __webpack_public_path__ + "e2b77b0070eb77547657d2e8b272efe3.pdf";